export function getRequestString(eventTriggerAction) {
  // public static final String EVENT_TRIGGER_ACTION_TRACK_THERAPY = "therapy";
  // public static final String EVENT_TRIGGER_ACTION_TRACK_ASSESSMENT = "assessment";

  // public static final String EVENT_TRIGGER_ACTION_TYPE_FOLLOW_UP = "follow-up";

  var requestString = ''

  if (eventTriggerAction?.actionType === 'follow-up') {
    requestString += 'Follow up on '
  }

  if (eventTriggerAction?.actionTrack === 'therapy') {
    requestString += 'Therapy'
  }
  if (eventTriggerAction?.actionTrack === 'assessment') {
    requestString += 'Assessment'
  }
  return requestString
}
